var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAremxyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79888 10.0363H4.38268L5.08391 7.32205H6.05192L5.50313 5.15808H8.44524L10.4727 11.7899H7.30193L6.79888 10.027V10.0363ZM16.6237 0C18.4301 0 19.9164 1.80952 19.9164 4.02946C19.9164 6.24939 18.4378 8.05891 16.6237 8.05891H15.0155V11.8179H12.02V5.11144H15.9453C16.4332 5.11144 16.8295 4.62641 16.8295 4.02946C16.8295 3.4325 16.4332 2.94747 15.9453 2.94747L5.4574 2.9568L3.10218 11.7992H0L3.52139 0H16.6085H16.6237Z",
    fill: "#04177F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAremxyLogo);
export default __webpack_public_path__ + "static/media/AremxyLogo.6344f418961d8a3ed28e972b463b1ed5.svg";
export { ForwardRef as ReactComponent };